import React, { useState, useEffect } from 'react';
import FacturasView from './FacturasView';
import { httpGet } from '../../http';

const Facturas = (props) => {

    const [ request, setRequest ] = useState({
        loading: true,
        error: false,
        errorMsg: ''
    });

    const [ facturas, setFacturas ] = useState([]);

    useEffect(() => {
        getFacturas();
    }, []);    

    const getFacturas = async () => {

        setRequest({
            ...request,
            loading: true,
            error: false,
            errorMsg: ''
        });

        const estado = JSON.parse(sessionStorage.getItem('estado'));
        const reqFacturas = await httpGet('/ProveedoresWS/api/nota/facturas?emp=' + sessionStorage.getItem('companyId') + '&tercero=' + estado.proveedor.nit);
        console.log(reqFacturas);
        if(reqFacturas.data){
            setFacturas(reqFacturas.data);
        }

        setRequest({
            ...request,
            loading: false,
            error: false,
            errorMsg: ''
        });
    }

    const handleViewClick = (e, factura) => {
        e.preventDefault();
        const egreso = {
            co: factura.docFcCo,
            tipoDoc: factura.docFcTipo,
            numeroDoc: factura.documentoFc
        };

        console.log(egreso);

        props.history.push({ pathname: '/portal/egreso-detalle', state: { egreso: egreso } });
    }

    return <FacturasView request={request} facturas={facturas} onViewClick={handleViewClick} />
}

export default Facturas;